import { useAppSelector } from '@/store/store.ts'
import { Outlet } from 'react-router-dom'

export default function ProtectedRoute() {
	const user = useAppSelector(({ auth }) => auth.user)

	// if (isLoading) {
	// 	return <Loader isLoading={true} text="Checking authentication..." />
	// }

	if (user === undefined) {
		return <></>
	}

	// console.log(session)
	//
	// if (session === undefined) {
	// 	// TODO: add this to env
	// 	console.log(location)
	// 	const redir = `https://phoenix-frontend.local.gd:9150/auth/callback`
	// 	const from = `https://phoenix-frontend.local.gd:9150${location.pathname}`
	// 	// window.location.href = `https://telstra-auth.local.gd/backend/login/redir?redir=${encodeURIComponent(redir)}&from=${encodeURIComponent(from)}`
	// 	return <div>error</div>
	// }

	return <Outlet />
}
